import Card from '../../shared/Card';
import Header from '../../shared/Header';
import { Stack } from '../../shared/layouts';
import OverviewDetailRow from '../../shared/OverviewDetailRow';
import { useTranslation } from 'react-i18next';

const CapitalCard = ({
  capital: {
    description,
    registration_number,
    start_date,
    company,
    product_type,
    product,
    contract_number,
    account_number,
    offset_account_number,
  },
  index,
  isMinDesktop,
}) => {
  const { t } = useTranslation();

  return (
    <Card fontSize={isMinDesktop ? 'm' : 's'}>
      <Stack space={isMinDesktop ? 'l' : 'm'}>
        <Header
          title={`${company || ''} ${product ||
            t('Vermogen') + ` ` + (index + 1)}`}
          variant="section"
          fontSize={isMinDesktop ? 'l' : 's'}
        />
        <Stack space={'none'} divider={'default'}>
          <OverviewDetailRow
            descriptor={t('Omschrijving') + `:`}
            value={description}
            hideIfEmpty
          />
          <OverviewDetailRow
            descriptor={t('Registratienummer') + `:`}
            value={registration_number}
            hideIfEmpty
          />
          <OverviewDetailRow
            descriptor={t('Startdatum') + `:`}
            value={start_date}
            hideIfEmpty
          />
          <OverviewDetailRow
            descriptor={t('Maatschappij') + `:`}
            value={company}
            hideIfEmpty
          />
          <OverviewDetailRow
            descriptor={t('Product type') + `:`}
            value={product_type}
            hideIfEmpty
          />
          <OverviewDetailRow
            descriptor={t('Product') + `:`}
            value={product}
            hideIfEmpty
          />
          <OverviewDetailRow
            descriptor={t('Overeenkomstnummer') + `:`}
            value={contract_number}
            hideIfEmpty
          />
          <OverviewDetailRow
            descriptor={t('IBAN rekeningnummer') + `:`}
            value={account_number}
            hideIfEmpty
          />
          <OverviewDetailRow
            descriptor={t('IBAN tegenrekening') + `:`}
            value={offset_account_number}
            hideIfEmpty
          />
        </Stack>
      </Stack>
    </Card>
  );
};

export default CapitalCard;
